import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { EventAttendSearch, EventMaster } from '../models/event';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  constructor(
    private http: HttpClient,
    private commonService: CommonService
  ) {
    let openEvent: EventMaster = new EventMaster('OPEN_EVENT', '오픈이벤트', '오아시스 버디 챌린지 - SNS공유 3회 달성 미션!(3,000 / 7,000 / 10,000)')
    this.eventList.push(openEvent)
  }
  eventList: EventMaster[] = new Array()
  getEventMaster(type: string): EventMaster {
    return this.eventList.find(em => em.type == type)
  }
  getEventAttendList(search: EventAttendSearch) {
    let param = JSON.parse(JSON.stringify(search))
    if(param.status == '') param.status = null
    if(param.fromDate != null) param.fromDate = search.fromDate.format('YYYY-MM-DD')
    if(param.toDate != null) param.toDate = search.toDate.format('YYYY-MM-DD')
    return this.http.post<any>(this.commonService.apiUrl + '/event/attend/list', param)
  }
  addEventAttend(type: string, transId: string, status: string) {
    return this.http.post<any>(this.commonService.apiUrl + '/event/attend', {
        type: type
      , transId: transId
      , status: status
    })
  }
  updateEventAttendStatus(type: string, eventIds: number[], status: string) {
    return this.http.post<any>(this.commonService.apiUrl + '/event/attend/status/update', {
        type: type
      , eventIds: eventIds
      , status: status
    })
  }
}
